import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import UserTracking from './components/UserTracking';
import SiteVisitTracker from './components/SiteVisitTracker';
import WithSeo from './components/WithSeo';
import './theme.css';
import BottomCallAction from './Share/BottomCallAction';
import Header from './Share/Header';
import Footer from './Share/Footer';
import OfferTop from './Share/OfferTop';
import ScrollToTop from './components/ScrollToTop'; // adjust path if needed
import PricingFAQ from './Home/Pricingfaq';   // wherever you put it

import HeroSection from './Home/Herosection';
import Benefits from './Home/Benefits';
import AboutSection from './Home/Aboutsection';
import StudentArea from './Home/StudentArea';
import FunFactArea from './Home/FunFactArea';
import ClassesSection from './Home/Classessection';
import BrandArea from './Home/BrandArea';
import Events from './Home/Events';
import AllEvents from './Home/AllEvents';
import TestimonialSection from './Home/TestimonialSection';
import CertificatesSection from './Home/CertificatesSection';
import PricingArea from './Home/PricingArea';
import FreeDemoSection from './Home/FreeDemoSection';
import AboutUs from './Home/AboutUs';
import Wedo20 from './Share/Wedo20';
import StemAccreditationSection from './Home/StemAccreditationSection';
import OfferSection from './Home/OfferSection';
import Login from './Share/Login';
import Joinfreeclass from './Share/Joinfreeclass';
import Curriculum from './Share/Curriculum';
import FreeTrial from './Share/FreeTrial';
import FreeTrialLanding from './Share/FreeTrialLanding';

import AllPrograms from './Share/AllPrograms';
import StudentAchievements from './Home/StudentAchievements';
import Terms from './Share/Terms';
import Privacy from './Share/Privacy';
import DemoClass from './DemoStudents/DemoClass';
import DemoMyClasses from './DemoStudents/DemoMyClasses';
import RoboticsServices from './Home/RoboticsServices';
import AdminSettings from './Admin/Adminsettings';
import AdminVisitors from './Admin/AdminVisitors';
import AdminParentFeedback from './Admin/AdminParentFeedback';
import ParentFeedback from './Share/ParentFeedback';
import ParentReviews from './Home/ParentReviews';
import StudentDashboard from './Student/Dashboard';
import StudentMyClasses from './Student/MyClasses';
import StudentSchedule from './Student/MySchedule';
import StudentCertificates from './Student/MyCertificates';
import StudentCompetitions from './Student/Competitions';
import StudentBadges from './Student/Badges';
import StudentSettings from './Student/Settings';

import Layout from './Student/Layout';
import DemoLayout from './DemoStudents/Layout';

import LayoutTeacher from './Teacher/Layout';
import TeacherDashboard from './Teacher/Dashboard';
import TeacherMyClasses from './Teacher/MyClasses';
import TeacherSchedule from './Teacher/MySchedule';
import TeacherCurriculum from './Teacher/Curriculum';
import TeacherEarnings from './Teacher/MyEarnings';
import TeacherMyStudents from './Teacher/MyStudents';
import TeacherCompetitions from './Teacher/Competitions';
import TeacherBadges from './Teacher/Badges';
import TeacherStudentProfile from './Teacher/StudentProfile';
import TeacherSettings from './Teacher/Settings';

import LayoutAdmin from './Admin/Layout';
import AdminDashboard from './Admin/Dashboard';
import AdminMyClasses from './Admin/MyClasses';
import AdminUsers from './Admin/Users';
import AdminTeacherProfile from './Admin/TeacherProfile';
import AdminStudentProfile from './Admin/StudentProfile';
import AdminCurriculum from './Admin/Curriculum';
import AdminEarnings from './Admin/MyEarnings';
import AdminMyStudents from './Admin/MyAdminStudents';
import AdminMyCertificates from './Admin/MyCertificates';
import AdminReferrals from './Admin/Referrals';
import AdminCompetitions from './Admin/Competitions';
import AdminAwards from './Admin/Awards';
import AdminPrices from './Admin/PricesAndOffers';
import AdminMyEvents from './Admin/MyEvents';
import AdminSendEmails from './Admin/SendEmails';
import AdminEmailStudio from './Admin/EmailStudio/EmailStudio';
import AdminNotificationsPage from './Admin/NotificationsPage';
import LayoutSales from './Sales/Layout';
import SalesUsers from './Sales/Users';
import SalesAllStudents from './Sales/AllStudents';

import SalesDashboard from './Sales/Dashboard';
import SalesTeacherProfile from './Sales/TeacherProfile';
import SalesMyClasses from './Sales/MyClasses';
import SalesAllClasses from './Sales/AllClasses';
import SalesSchedule from './Sales/MySchedule';
import SalesCurriculum from './Sales/Curriculum';
import SalesEarnings from './Sales/MyEarnings';
import SalesMyStudents from './Sales/MyStudents';
import SalesStudentProfile from './Sales/StudentProfile';
import SalesSettings from './Sales/Settings';

const WithLayout = ({ children }) => (
  <>
    <OfferTop />
    <Header />
    {children}
    <Footer />
  </>
);
// Student protected route wrapper
const DemoRoute = ({ children }) => {
  return <DemoLayout>{children}</DemoLayout>;
};
// Role-checking function
const getUserRole = async () => {
  const storedToken = localStorage.getItem('userData');
  const userToken = storedToken ? JSON.parse(storedToken) : null;

  if (!userToken) return null;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/verify`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Unauthorized');

    const data = await response.json();
    return data.role;
  } catch (error) {
    console.error('Role check failed:', error);
    return null;
  }
};

// Student protected route wrapper
const StudentRoute = ({ children }) => {
  const [role, setRole] = useState(null);
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getUserRole().then((r) => {
      setRole(r);
      setChecked(true);
    });
  }, []);

  if (!checked) return null;

  if (role !== 3) {
    return <Navigate to="/login" replace />;
  }

  return <Layout>{children}</Layout>;
};

// Teacher protected route wrapper
const TeacherRoute = ({ children }) => {
  const [role, setRole] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    getUserRole().then((r) => {
      setRole(r);
      setChecked(true);
    });
  }, []);

  if (!checked) return null;

  if (role !== 2) {
    return <Navigate to="/login" replace />;
  }

  return <LayoutTeacher>{children}</LayoutTeacher>;
};

// Sales protected route wrapper
const SalesRoute = ({ children }) => {
  const [role, setRole] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    getUserRole().then((r) => {
      setRole(r);
      setChecked(true);
    });
  }, []);

  if (!checked) return null;

  if (role !== 4) {
    return <Navigate to="/login" replace />;
  }

  return <LayoutSales>{children}</LayoutSales>;
};

// Admin protected route wrapper
const AdminRoute = ({ children }) => {
  const [role, setRole] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    getUserRole().then((r) => {
      setRole(r);
      setChecked(true);
    });
  }, []);

  if (!checked) return null;

  if (role !== 1) {
    return <Navigate to="/login" replace />;
  }

  return <LayoutAdmin>{children}</LayoutAdmin>;
};

const App = () => {
  useEffect(() => {
    const checkForUpdates = () => {
      fetch('/meta.json', { cache: 'no-store' })
        .then(res => res.json())
        .then(meta => {
          console.log(meta.version);
          console.log(process.env.REACT_APP_VERSION);
          if (meta.version !== process.env.REACT_APP_VERSION) {
              window.location.reload(true);
          }
        });
    };

    checkForUpdates();
    const interval = setInterval(checkForUpdates, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
      <UserTracking />
      <SiteVisitTracker />
      <ScrollToTop />   {/* <-- Add this here */}

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <WithSeo
              title="Home"
              description="Live 1-to-1 online coding, AI and robotics classes for kids and teens (ages 6–17) in Lebanon and abroad. Scratch, Python, web, games and AI. Book a free trial class."
              keywords="coding for kids Lebanon, coding classes Lebanon, online coding classes, robotics for kids, AI for kids, Python for kids, Scratch, STEM education"
            >
              <WithLayout>
                <div className="rm-page">

                <HeroSection />
                <Benefits />
                <StudentArea />
                <StemAccreditationSection />
                <OfferSection />
                <ClassesSection />
                <PricingArea />
                <ParentReviews />
                <FreeDemoSection />
                </div>
              </WithLayout>
            </WithSeo>
          }
        />

        {/* Pricing */}
        <Route
          path="/PricingPlans"
          element={
            <WithSeo
              title="Pricing Plans"
              description="Prices for RoboMind's live 1-to-1 online coding, AI and robotics classes for kids in Lebanon. Packages of 8, 24 or 40 sessions, flexible schedule, payment by Whish, OMT or bank transfer."
              keywords="coding class pricing, online course fees, affordable coding classes, payment plans, subscription options"
            >
              <WithLayout>
                <div className="rm-page">
                  <PricingArea asPage />
                  <StemAccreditationSection />
                  <PricingFAQ />

                  <FreeDemoSection />
                </div>
              </WithLayout>

            </WithSeo>
          }
        />

        {/* Other Public Pages */}
        <Route path="/Programs" element={
          <WithSeo
            title="Our Programs"
            description="Coding, AI and robotics courses for kids aged 6–17 in Lebanon: Scratch, Python, web and game development, AI, mobile apps, Arduino, Micro:bit and more. Live 1-to-1 online."
            keywords="coding programs, scratch programming, python for kids, web development, game design, robotics courses"
          >
            <WithLayout>
              <div className="rm-page">
              <AllPrograms />
              <PricingArea />
              <FreeDemoSection />
              </div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/FreeTrial" element={
            <WithSeo
              title="Free Coding Trial for Kids | RoboMind"
              description="Book a free live 1-to-1 coding class for your child (ages 6–17) in Lebanon or abroad. Coding, game development, apps, AI and robotics."
              keywords="free coding class Lebanon, free trial coding for kids, online coding classes, kids programming"
            >
            <WithLayout>
                            <div className="rm-page">

              <FreeTrialLanding />
              <FreeTrial />
              <StemAccreditationSection />
  
</div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/StudentAchievements" element={
          <WithSeo
            title="Student Achievements"
            description="See our students' amazing projects and achievements in coding, robotics, and STEM competitions. Success stories and testimonials."
            keywords="student projects, coding achievements, success stories, testimonials, competition winners"
          >
            <WithLayout>
                <div className="rm-page">
                  <StudentAchievements />
                </div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/AboutUs" element={
          <WithSeo
            title="About Us"
            description="Learn about RoboMind's mission to provide quality coding education for children. Our team, teaching methodology, and accreditation."
            keywords="about RoboMind, our mission, teaching methodology, STEM accreditation, certified teachers"
          >
            <WithLayout>
              <div className="rm-page">
                <AboutUs />
                <StudentArea />
                <FreeDemoSection />
              </div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/Events" element={
          <WithSeo
            title="Events & Workshops"
            description="Join our coding workshops, hackathons, and STEM events. Upcoming competitions, webinars, and special programs for young coders."
            keywords="coding workshops, STEM events, hackathons, programming competitions, webinars"
          >
            <WithLayout>
              <div className="rm-page">
                <AllEvents />
                <RoboticsServices />
              </div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/Wedo20" element={
          <WithSeo
            title="WeDo 2.0 Robotics"
            description="LEGO Education WeDo 2.0 robotics program for kids. Learn robotics, coding, and engineering concepts through hands-on projects."
            keywords="WeDo 2.0, LEGO robotics, robotics for kids, STEM robotics, coding and robotics"
          >
            <WithLayout>
              <div className="rm-page">
                <Wedo20 /> 
              </div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/Login" element={
          <WithSeo
            title="Login"
            description="Login to your RoboMind student, teacher, or admin dashboard. Access your classes, schedule, and learning materials."
            keywords="student login, teacher login, dashboard access, account login"
          >
            <WithLayout>
              <Login />
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/joinfreeclass" element={
          <WithSeo
            title="Join Free Class"
            description="Join a free coding class using your access code. Start your coding journey with RoboMind's interactive platform."
            keywords="join class, free coding session, access code, live coding class"
          >
            <WithLayout>
              <div className="rm-page">
              <Joinfreeclass />
              </div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/Curriculum" element={
          <WithSeo
            title="Curriculum"
            description="Our comprehensive coding curriculum designed for different age groups and skill levels. Learn programming step by step."
            keywords="coding curriculum, syllabus, learning path, course structure, programming modules"
          >
            <WithLayout>                
              <div className="rm-page">
                <Curriculum />
              </div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/terms" element={
          <WithSeo
            title="Terms & Conditions"
            description="RoboMind terms and conditions, policies, and user agreement. Read our terms of service before enrolling."
            keywords="terms and conditions, policies, user agreement, terms of service"
          >
            <WithLayout>
           <div className="rm-page">  <Terms /></div> 
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/privacy" element={
          <WithSeo
            title="Privacy Policy"
            description="RoboMind privacy policy. Learn how we protect your data and ensure safe online learning environment."
            keywords="privacy policy, data protection, online safety, GDPR compliance"
          >
            <WithLayout>
             <div className="rm-page"> <Privacy /></div>
            </WithLayout>
          </WithSeo>
        } />

        <Route path="/DemoClass/myclasses" element={
          <WithSeo title="My Classes">
            <DemoRoute>
              <DemoMyClasses />
            </DemoRoute>
          </WithSeo>
        } />

        <Route path="/DemoClass" element={
          <WithSeo
            title="Demo Class Registration"
            description="Register for a free demo coding class. Experience our teaching methodology and interactive platform."
            keywords="demo registration, free class signup, trial registration, book demo"
          >
            <DemoRoute>
              <DemoClass />
              <PricingArea />
              <StemAccreditationSection />
            </DemoRoute>
          </WithSeo>
        } />

        {/* Protected Student Routes */}
        <Route path="/student/dashboard" element={
          <WithSeo title="Student Dashboard">
            <StudentRoute>
              <StudentDashboard />
            </StudentRoute>
          </WithSeo>
        } />
        
        <Route path="/student/myclasses" element={
          <WithSeo title="My Classes">
            <StudentRoute>
              <StudentMyClasses />
            </StudentRoute>
          </WithSeo>
        } />
        
        <Route path="/student/schedule" element={
          <WithSeo title="My Schedule">
            <StudentRoute>
              <StudentSchedule />
            </StudentRoute>
          </WithSeo>
        } />
        
        <Route path="/student/certificates" element={
          <WithSeo title="My Certificates">
            <StudentRoute>
              <StudentCertificates />
            </StudentRoute>
          </WithSeo>
        } />
        
        <Route path="/student/competitions" element={
          <WithSeo title="Competitions">
            <StudentRoute>
              <StudentCompetitions />
            </StudentRoute>
          </WithSeo>
        } />

        <Route path="/student/badges" element={
          <WithSeo title="Badges">
            <StudentRoute>
              <StudentBadges />
            </StudentRoute>
          </WithSeo>
        } />

        <Route path="/student/settings" element={
          <WithSeo title="Settings">
            <StudentRoute>
              <StudentSettings />
            </StudentRoute>
          </WithSeo>
        } />
        
     
        {/* Protected Teacher Routes */}
        <Route path="/teacher/Dashboard" element={
          <WithSeo title="Teacher Dashboard">
            <TeacherRoute>
              <TeacherDashboard />
            </TeacherRoute>
          </WithSeo>
        } />
        
        <Route path="/teacher/MyClasses" element={
          <WithSeo title="My Classes">
            <TeacherRoute>
              <TeacherMyClasses />
            </TeacherRoute>
          </WithSeo>
        } />
        
        <Route path="/teacher/MySchedule" element={
          <WithSeo title="My Schedule">
            <TeacherRoute>
              <TeacherSchedule />
            </TeacherRoute>
          </WithSeo>
        } />
        
        <Route path="/teacher/Curriculum" element={
          <WithSeo title="Curriculum">
            <TeacherRoute>
              <TeacherCurriculum />
            </TeacherRoute>
          </WithSeo>
        } />
        
        <Route path="/teacher/MyEarnings" element={
          <WithSeo title="My Earnings">
            <TeacherRoute>
              <TeacherEarnings />
            </TeacherRoute>
          </WithSeo>
        } />
        
        <Route path="/teacher/Settings" element={
          <WithSeo title="Settings">
            <TeacherRoute>
              <TeacherSettings />
            </TeacherRoute>
          </WithSeo>
        } />
        
        <Route path="/teacher/competitions" element={
          <WithSeo title="Competitions">
            <TeacherRoute>
              <TeacherCompetitions />
            </TeacherRoute>
          </WithSeo>
        } />

        <Route path="/teacher/badges" element={
          <WithSeo title="Badges">
            <TeacherRoute>
              <TeacherBadges />
            </TeacherRoute>
          </WithSeo>
        } />

        <Route path="/teacher/MyStudents" element={
          <WithSeo title="My Students">
            <TeacherRoute>
              <TeacherMyStudents />
            </TeacherRoute>
          </WithSeo>
        } />
        
        <Route path="/StudentProfile/:studentId" element={
          <WithSeo title="Student Profile">
            <TeacherRoute>
              <TeacherStudentProfile />
            </TeacherRoute>
          </WithSeo>
        } />

        {/* Protected Sales Routes */}
        <Route path="/sales/Dashboard" element={
          <WithSeo title="Sales Dashboard">
            <SalesRoute>
              <SalesDashboard />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/MyClasses" element={
          <WithSeo title="My Classes">
            <SalesRoute>
              <SalesMyClasses />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/MySchedule" element={
          <WithSeo title="My Schedule">
            <SalesRoute>
              <SalesSchedule />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/Curriculum" element={
          <WithSeo title="Curriculum">
            <SalesRoute>
              <SalesCurriculum />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/MyEarnings" element={
          <WithSeo title="My Earnings">
            <SalesRoute>
              <SalesEarnings />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/Settings" element={
          <WithSeo title="Settings">
            <SalesRoute>
              <SalesSettings />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/MyStudents" element={
          <WithSeo title="My Students">
            <SalesRoute>
              <SalesMyStudents />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/StudentProfile/:id" element={
          <WithSeo title="Student Profile">
            <SalesRoute>
              <SalesStudentProfile />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/users" element={
          <WithSeo title="Users">
            <SalesRoute>
              <SalesUsers />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/teacherprofile/:id" element={
          <WithSeo title="Teacher Profile">
            <SalesRoute>
              <SalesTeacherProfile />
            </SalesRoute>
          </WithSeo>
        } />
        
        <Route path="/sales/AllClasses" element={
          <WithSeo title="All Classes">
            <SalesRoute>
              <SalesAllClasses />
            </SalesRoute>
          </WithSeo>
        } />

        {/* Protected Admin Routes */}
        <Route path="/Admin/Dashboard" element={
          <WithSeo title="Admin Dashboard">
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          </WithSeo>
        } />
        
        <Route path="/Admin/MyClasses" element={
          <WithSeo title="Classes">
            <AdminRoute>
              <AdminMyClasses />
            </AdminRoute>
          </WithSeo>
        } />
        
        <Route path="/Admin/Curriculum" element={
          <WithSeo title="Curriculum">
            <AdminRoute>
              <AdminCurriculum />
            </AdminRoute>
          </WithSeo>
        } />
        
        <Route path="/Admin/MyEarnings" element={
          <WithSeo title="Earnings">
            <AdminRoute>
              <AdminEarnings />
            </AdminRoute>
          </WithSeo>
        } />
        
        <Route path="/Admin/users" element={
          <WithSeo title="Users">
            <AdminRoute>
              <AdminUsers />
            </AdminRoute>
          </WithSeo>
        } />
        
        <Route path="/Admin/teacherprofile/:id" element={
          <WithSeo title="Teacher Profile">
            <AdminRoute>
              <AdminTeacherProfile />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/studentprofile/:id" element={
          <WithSeo title="Student Profile">
            <AdminRoute>
              <AdminStudentProfile />
            </AdminRoute>
          </WithSeo>
        } />
        
        <Route path="/Admin/MyadminStudents" element={
          <WithSeo title="Students">
            <AdminRoute>
              <AdminMyStudents />
            </AdminRoute>
          </WithSeo>
        } />
        
        <Route path="/Admin/MyCertificates" element={
          <WithSeo title="Certificates">
            <AdminRoute>
              <AdminMyCertificates />
            </AdminRoute>
          </WithSeo>
        } />
        
        <Route path="/Admin/Competitions" element={
          <WithSeo title="Competitions">
            <AdminRoute>
              <AdminCompetitions />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/Badges" element={
          <WithSeo title="Badges">
            <AdminRoute>
              <AdminAwards />
            </AdminRoute>
          </WithSeo>
        } />

        <Route path="/Admin/Referrals" element={
          <WithSeo title="Referrals">
            <AdminRoute>
              <AdminReferrals />
            </AdminRoute>
          </WithSeo>
        } />

        <Route path="/Admin/PricesAndOffers" element={
          <WithSeo title="Prices & Offers">
            <AdminRoute>
              <AdminPrices />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/sendemails" element={
          <WithSeo title="Send Emails">
            <AdminRoute>
              <AdminEmailStudio />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/sendemails-classic" element={
          <WithSeo title="Send Emails (classic)">
            <AdminRoute>
              <AdminSendEmails />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/notifications" element={
          <WithSeo title="Notifications">
            <AdminRoute>
              <AdminNotificationsPage />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/MyEvents" element={
          <WithSeo title="Events">
            <AdminRoute>
              <AdminMyEvents />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/Settings" element={
          <WithSeo title="Settings">
            <AdminRoute>
              <AdminSettings />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/Visitors" element={
          <WithSeo title="Visitors">
            <AdminRoute>
              <AdminVisitors />
            </AdminRoute>
          </WithSeo>
        } />
        <Route path="/Admin/ParentFeedback" element={
          <WithSeo title="Parent feedback">
            <AdminRoute>
              <AdminParentFeedback />
            </AdminRoute>
          </WithSeo>
        } />

        {/* Parent feedback form (private link from the email / WhatsApp) */}
        <Route path="/feedback/:token" element={
          <WithSeo title="Your feedback">
            <WithLayout>
              <ParentFeedback />
            </WithLayout>
          </WithSeo>
        } />

        {/* Catch All Route */}
        <Route path="/*" element={
          <Navigate to="/" replace />
        } />
      </Routes>
    </Router>
  );
};

export default App;